module.exports = __webpack_public_path__ + "static/media/Automotriz.e4a41614.svg";